import { isTimeoutError, type Options, type BeforeErrorState } from "@otto-ec/global-resources/ky";
import type { Debug } from "@otto-ec/global-resources/debug";

const RETRY_ON_METHODS = ["get", "post", "put", "query"];

const kyTimeoutLoggingHook =
	(logger: Debug, url: string) =>
	({ error }: BeforeErrorState) => {
		if (isTimeoutError(error)) {
			logger.warn(`[fetch] Timeout fetch to ${url}`);
		}
		return error;
	};

export function createDefaultOptions(logger: Debug, url: string): Partial<Options> {
	return {
		retry: { limit: 2, retryOnTimeout: true, methods: RETRY_ON_METHODS },
		baseUrl: globalThis.location?.origin,
		hooks: {
			beforeError: [kyTimeoutLoggingHook(logger, url)],
		},
	};
}
